exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n * Variables\n */\n\n/**\n * Functions\n */\n\n/**\n * Mixins\n */\n.credit-card-existing-form[data-v-4cc10cce] {\n\tmax-width: 400px;\n\tmax-width: 25rem;\n\twidth: 100%;\n}\n.form-error[data-v-4cc10cce] {\n\twidth: 100%;\n\ttext-align: left;\n\tmargin: 0;\n}\n.return-link[data-v-4cc10cce] {\n\tfont-weight: normal;\n}\n", ""]);

// exports
